import "../../../css/DesignSystem/Tooltip/Tooltip.css";

const Tooltip = ({ content, position = "top", children }) => {
  return (
    <span className="ds-tooltip">
      {children}
      <span className={`Content ds-tooltip-content ds-tooltip-content--${position}`}>
        {content}
      </span>
    </span>
  );
};

export default Tooltip;
